import { render, staticRenderFns } from "./SideMenuNovel.vue?vue&type=template&id=3fac4d60&scoped=true"
import script from "./SideMenuNovel.vue?vue&type=script&lang=ts"
export * from "./SideMenuNovel.vue?vue&type=script&lang=ts"
import style0 from "./SideMenuNovel.vue?vue&type=style&index=0&id=3fac4d60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fac4d60",
  null
  
)

export default component.exports